import {
  CurrentToPriorKeysMatch,
  PartialMatch,
  TimePeriodType,
  TimePeriodComparisonType, TimePeriodTypeName,
} from "@/models/timePeriod.model.ts";
import { IOption } from "@/models/shared.model";
import { previousTimePeriods, timePeriods} from "@/helpers/timePeriod";

export const timePeriodFilterService = {
  isMonday: function(): boolean {
    return new Date().getDay() === 1;
  },
  isPeriodOptionDisabled: (timePeriod: keyof typeof TimePeriodType, option: keyof typeof TimePeriodComparisonType): boolean => {
    if (option === TimePeriodComparisonType.partialPeriod) {
      return [
        TimePeriodType.today,
        TimePeriodType.lastWeek,
        TimePeriodType.lastMonth,
        TimePeriodType.custom
      ].includes(TimePeriodType[timePeriod as keyof typeof TimePeriodType]);
    }

    return false;
  },
  getFilterOptions: function(): IOption<string>[] {
    const timePeriodFilterOptions = [
      TimePeriodType.today,
      TimePeriodType.thisWeek,
      TimePeriodType.lastWeek,
      TimePeriodType.thisMonth,
      TimePeriodType.lastMonth,
      TimePeriodType.custom,
    ];

    return timePeriodFilterOptions.map(key => {
      const typedKey = key as keyof typeof TimePeriodTypeName;
      return {
        value: key,
        name: TimePeriodTypeName[typedKey],
        tooltip: "",
      };
    });
  },
  getScoringFilterOptions: function(): IOption<string>[] {
    const timePeriodFilterOptions = [
      TimePeriodType.thisWeek,
      TimePeriodType.lastWeek,
      TimePeriodType.thisMonth,
      TimePeriodType.lastMonth,
      TimePeriodType.custom,
    ];

    return timePeriodFilterOptions.map(key => {
      const typedKey = key as keyof typeof TimePeriodTypeName;
      return {
        value: key,
        name: TimePeriodTypeName[typedKey],
        tooltip: "",
      };
    });
  },
  calculateDates: function(period = TimePeriodType.thisWeek, isPartial = false): ReturnType<typeof this.calculateDates> {
    const defaultPeriod = this.isMonday() ? TimePeriodType.lastWeek : TimePeriodType.thisWeek;
    const selectedPeriod = period || defaultPeriod;

    if (isPartial) {
      const [startDate, endDate] = timePeriods[selectedPeriod];
      const [previousStartDate, previousEndDate] = previousTimePeriods[PartialMatch[CurrentToPriorKeysMatch[selectedPeriod]]];

      return {
        startDate,
        endDate,
        previousStartDate,
        previousEndDate,
      };
    }

    const [startDate, endDate] = timePeriods[selectedPeriod];
    const [previousStartDate, previousEndDate] = previousTimePeriods[CurrentToPriorKeysMatch[selectedPeriod]];

    return {
      startDate,
      endDate,
      previousStartDate,
      previousEndDate,
    };
  },
};
